class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    // Hide legacy global loader if present
    const legacyLoader = document.querySelector('.loading-wrapper');
    if (legacyLoader) legacyLoader.style.display = 'none';
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      // Build fresh params from current form state only
      const baseParams = new URLSearchParams();
      baseParams.set('section_id', section.section);
      const newParams = new URLSearchParams(searchParams);

      // Append keys/values, preserving duplicates and dropping empty values
      const uniqueKeys = Array.from(new Set(Array.from(newParams.keys())));
      uniqueKeys.forEach((key) => {
        const values = newParams.getAll(key).filter((v) => v !== '');
        if (values.length === 0) return;
        values.forEach((value) => baseParams.append(key, value));
      });

      const url = `${window.location.pathname}?${baseParams.toString()}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        // Fallback: if response doesn't contain expected container, reload page with updated params
        const hasContainer = html.indexOf('ProductGridContainer') !== -1 || html.indexOf('product-grid') !== -1;
        if (!hasContainer) {
          const newUrl = `${window.location.pathname}${url.includes('?') ? '?' + url.split('?')[1].replace(/(^|&)section_id=[^&]*/g, '').replace(/^&/, '') : ''}`;
          window.location.href = newUrl;
          return;
        }
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const currentContainer = document.getElementById('ProductGridContainer');
    const nextContainer = parsed.getElementById('ProductGridContainer');
    if (nextContainer && currentContainer) {
      currentContainer.innerHTML = nextContainer.innerHTML;
    } else {
      // Fallback: replace entire collection block
      const nextCollection = parsed.querySelector('#ProductGridContainer .collection') || parsed.querySelector('.collection');
      const currentCollection = currentContainer ? currentContainer.querySelector('.collection') : document.querySelector('#ProductGridContainer .collection');
      if (nextCollection && currentCollection) {
        currentCollection.outerHTML = nextCollection.outerHTML;
      } else {
        // As a last resort, reload entire page with current query
        window.location.href = `${window.location.pathname}${window.location.search}`;
        return;
      }
    }

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // Ensure legacy global loader is hidden after content swap
    const legacyLoader = document.querySelector('.loading-wrapper');
    if (legacyLoader) legacyLoader.style.display = 'none';
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    // Prefer total count from paginate.items if provided
    let total = '';
    const totalNode = parsed.getElementById('FacetTotalCount');
    if (totalNode && totalNode.getAttribute('data-total')) {
      total = `ITEMS (${totalNode.getAttribute('data-total')})`;
    }
    const parsedCount = parsed.getElementById('ProductCount');
    const count = total || (parsedCount ? parsedCount.innerHTML : '');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    // Ensure legacy global loader is hidden after counts render
    const legacyLoader = document.querySelector('.loading-wrapper');
    if (legacyLoader) legacyLoader.style.display = 'none';

    // Update Apply button in the mobile filter drawer with the total count
    try {
      const totalValue = totalNode && totalNode.getAttribute('data-total');
      if (totalValue != null) {
        const countSpans = document.querySelectorAll('.mobile-facets__apply-count');
        countSpans.forEach((span) => {
          span.textContent = ` (${totalValue})`;
        });
      }
    } catch (e) {
      // no-op: avoid blocking if DOM not present
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        let newElementToActivate = null;
        if (newFacetDetailsElement.classList.contains('mobile-facets__details')) {
          newElementToActivate =
            newFacetDetailsElement.querySelector('.mobile-facets__close-button') ||
            newFacetDetailsElement.querySelector('.mobile-facets__summary');
        } else {
          newElementToActivate = newFacetDetailsElement.querySelector('.facets__summary');
        }

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.active-facets-mobile-drawer'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer = mobileForm.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const newParams = new URLSearchParams(searchParams);

    // Build clean query string from current form state only (drop empty values)
    const cleanParams = new URLSearchParams();
    const uniqueKeys = Array.from(new Set(Array.from(newParams.keys())));
    uniqueKeys.forEach((key) => {
      const values = newParams.getAll(key).filter((v) => v !== '');
      if (values.length === 0) return;
      values.forEach((value) => cleanParams.append(key, value));
    });

    const qs = cleanParams.toString();
    history.pushState({ searchParams: qs }, '', `${window.location.pathname}${qs && '?'.concat(qs)}`);
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    const wrapper = grid ? grid.closest('.shopify-section') : null;
    const sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : (grid ? grid.dataset.id : '');
    return [
      {
        section: sectionId,
      },
    ];
  }

  static getCurrentSortValue() {
    const selectorsInPriority = [
      '#FacetSortDrawerForm select[name="sort_by"]',
      '#FacetSortForm select[name="sort_by"]',
      '#FacetFiltersFormMobile select[name="sort_by"]',
      '#FacetFiltersForm select[name="sort_by"]',
    ];
    for (let i = 0; i < selectorsInPriority.length; i += 1) {
      const el = document.querySelector(selectorsInPriority[i]);
      if (el && el.value) return el.value;
    }
    const urlParams = new URLSearchParams(window.location.search.slice(1));
    return urlParams.get('sort_by');
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const form = event.target.closest('form');
      const params = new URLSearchParams(this.createSearchParams(form));
      // Ensure current sort_by is preserved when filtering from the drawer/mobile form
      const currentSort = FacetFiltersForm.getCurrentSortValue();
      if (currentSort) params.set('sort_by', currentSort);
      this.onSubmitForm(params.toString(), event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm'
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      // Aggregate params coming from forms (e.g., sort), preserving duplicates
      const formParams = new URLSearchParams();
      forms.forEach((qs) => {
        const p = new URLSearchParams(qs);
        const keys = Array.from(new Set(Array.from(p.keys())));
        keys.forEach((key) => {
          const values = p.getAll(key);
          values.forEach((v) => {
            if (v !== '') formParams.append(key, v);
          });
        });
      });

      // Start from existing URL params (keeps currently active filters)
      const existing = new URLSearchParams(window.location.search.slice(1));
      const finalParams = new URLSearchParams();
      Array.from(new Set(Array.from(existing.keys()))).forEach((key) => {
        if (key === 'section_id') return;
        const values = existing.getAll(key).filter((v) => v !== '');
        values.forEach((v) => finalParams.append(key, v));
      });

      // Overlay form params (e.g., updated sort_by)
      Array.from(new Set(Array.from(formParams.keys()))).forEach((key) => {
        finalParams.delete(key);
        const values = formParams.getAll(key).filter((v) => v !== '');
        values.forEach((v) => finalParams.append(key, v));
      });

      // Ensure sort_by present
      const currentSort = FacetFiltersForm.getCurrentSortValue();
      if (currentSort && !finalParams.get('sort_by')) finalParams.set('sort_by', currentSort);
      this.onSubmitForm(finalParams.toString(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Mark legacy global loader as hidden on facets pages
function hideLegacyLoaderForFacets() {
  try {
    const loader = document.querySelector('.loading-wrapper');
    if (loader) loader.classList.add('is-hidden-on-facets');
  } catch (_) {}
}

// Initialize Apply button count from the current DOM on load
function updateApplyButtonCountFromDom() {
  try {
    const totalNode = document.getElementById('FacetTotalCount');
    if (!totalNode) return;
    const totalValue = totalNode.getAttribute('data-total');
    if (totalValue == null) return;
    const countSpans = document.querySelectorAll('.mobile-facets__apply-count');
    countSpans.forEach((span) => {
      span.textContent = ` (${totalValue})`;
    });
  } catch (_) {}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.collection-with-filters') || document.querySelector('facet-filters-form')) {
      hideLegacyLoaderForFacets();
      updateApplyButtonCountFromDom();
    }
  });
} else if (document.querySelector('.collection-with-filters') || document.querySelector('facet-filters-form')) {
  hideLegacyLoaderForFacets();
  updateApplyButtonCountFromDom();
}

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


// Click-outside fallback to close the mobile facets drawer, including overlay clicks
(function () {
  function handleOutsideClick(event) {
    var drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    if (!drawer) return;
    var details = drawer.querySelector('details');
    if (!details || !details.hasAttribute('open')) return;

    var mobileForm = document.getElementById('FacetFiltersFormMobile');
    var inner = mobileForm ? mobileForm.querySelector('.mobile-facets__inner') : null;

    var clickedInsideDrawer = drawer.contains(event.target);
    var clickedInsideInner = inner ? inner.contains(event.target) : false;

    // Close if click is entirely outside the drawer OR on the overlay within the drawer
    var isOverlayClick = clickedInsideDrawer && !clickedInsideInner;
    if (!clickedInsideDrawer || isOverlayClick) {
      var summary = details.querySelector('summary');
      if (summary) summary.click();
    }
  }

  function bindOutsideClick() {
    if (window.__facetsOutsideClickBound) return;
    document.addEventListener('click', handleOutsideClick);
    window.__facetsOutsideClickBound = true;
  }

  function shouldEnable() {
    return (
      document.querySelector('.collection-with-filters') ||
      document.querySelector('facet-filters-form')
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (shouldEnable()) bindOutsideClick();
    });
  } else {
    if (shouldEnable()) bindOutsideClick();
  }
})();

(function(){
  function slugify(text){
    return (text||'').toLowerCase().trim().replace(/ \/ /g,'---').replace(/[^a-z0-9-]/g,'-');
  }
  function findStyleId(tags, sku){
    var styleId='';
    if (Array.isArray(tags)){
      for (var i=0;i<tags.length;i++){
        var t=tags[i];
        if (t && t.indexOf('style_id_')!==-1){
          styleId = t.replace('style_id_','');
          if (sku && sku.indexOf(styleId)!==-1) break;
        }
      }
    }
    if (!styleId && sku){ styleId = sku.split('-')[0]; }
    return styleId;
  }
  function addSize(url,size){
    try{
      if(!url||!size) return url;
      var parts=url.split('?');
      var base=parts[0];
      var qs=parts[1]?'?'+parts[1]:'';
      base=base.replace(/_(\d+x)\./,'_'+size+'.');
      if(!/_(\d+x)\./.test(base)){ base=base.replace(/(\.[a-zA-Z0-9]+)$/,'_'+size+'$1'); }
      return base+qs;
    }catch(e){ return url; }
  }
  function renderCard(colorsEl){
    var box = colorsEl.querySelector('.cf-swatch-box');
    if(!box || box.__rendered || box.__rendering) return;
    var container = colorsEl.closest('.product-container');
    var handle = container ? container.getAttribute('data-product-handle') : '';
    var jsonEl = colorsEl.querySelector('.plp-product-json');
    var product = {};
    try{ product = jsonEl ? JSON.parse(jsonEl.textContent||'{}') : {}; }catch(_){ product={}; }
    if(!handle && product && product.handle){ handle = product.handle; }
    if(!handle){ return; }
    box.__rendering = true;
    var cache = window.__mergeCache = window.__mergeCache || {};
    var cached = cache[handle];
    var proceed = function(merge){
      try{
        var optionNames = Array.isArray(merge && merge.optionNames)? merge.optionNames : [];
        var colorIdx = optionNames.map(function(n){return (n||'').toLowerCase();}).findIndex(function(n){return n==='color'||n==='colour';});
        var colorValues = colorIdx>=0 ? (merge['option'+(colorIdx+1)+'Values']||[]) : [];
        var images = Array.isArray(merge && merge.images)? merge.images : [];
        var variants = Array.isArray(merge && merge.variants)? merge.variants : [];
        var tags = Array.isArray(merge && merge.mergedTags)? merge.mergedTags : (product.tags||[]);
        var featSrc = (product.featured_image && product.featured_image.src) || product.featured_image || (product.images && product.images[0]) || '';
        var productImgUrl = addSize(featSrc, '450x');
        var swatches=[];
        // If no explicit color values, derive from image alts
        if (!colorValues.length && images.length){
          var seenAlt={};
          images.forEach(function(img){ var a=(img.alt||'').trim(); if(!a) return; var k=a.toLowerCase(); if(!seenAlt[k]){ seenAlt[k]=true; colorValues.push(a); }});
        }
        colorValues.forEach(function(color){
          var cLower=(color||'').toLowerCase();
          var colorVariants = variants.filter(function(v){
            var name=(v['option'+(colorIdx+1)]||'').toLowerCase();
            return name===cLower || (v.title||'').toLowerCase().indexOf(cLower)!==-1 || (v.public_title||'').toLowerCase().indexOf(cLower)!==-1;
          });
          var available = colorVariants.length ? colorVariants.some(function(v){ return !!v.available; }) : true;
          var sku = (colorVariants[0] && colorVariants[0].sku) || '';
          var vId = (colorVariants[0] && colorVariants[0].id);
          var info = merge && merge.productInfo;
          var mapped = info && vId ? info[vId] : null;
          var mappedHandle = mapped && mapped.handle ? mapped.handle : handle;
          var match = images.find(function(img){ return (img.alt||'').toLowerCase()===cLower; });
          var colorImg = match && match.src ? match.src : productImgUrl;
          var altArr = images.filter(function(img){ return (img.alt||'').toLowerCase()===cLower; });
          var colorAltImg = (altArr[1] && altArr[1].src) ? altArr[1].src : colorImg;
          var priceMin = colorVariants.length ? Math.min.apply(null, colorVariants.map(function(v){ return v.price; })) : (product.price_min || product.price || 0);
          var priceMax = colorVariants.length ? Math.max.apply(null, colorVariants.map(function(v){ return v.price; })) : (product.price_max || product.price || 0);
          var priceVaries = priceMin !== priceMax;
          var compareAtPrice = null;
          if (colorVariants.length) {
            var onSaleV = colorVariants.find(function(v){ return v.compare_at_price && v.compare_at_price > v.price; });
            compareAtPrice = onSaleV ? onSaleV.compare_at_price : (colorVariants[0].compare_at_price || null);
          } else if (product.compare_at_price && product.compare_at_price > product.price) {
            compareAtPrice = product.compare_at_price;
          }
          swatches.push({ title: color, available: available, sku: sku, image: colorImg, imageAlt: colorAltImg, tags: tags, handle: mappedHandle, price_min: priceMin, price_max: priceMax, price_varies: priceVaries, compare_at_price: compareAtPrice });
        });
        if (!swatches.length || swatches.length<=1){
          var parent = box.closest('.product-colors') || box.parentElement; if(parent) parent.style.display='none';
          box.__rendering=false; return;
        }
        var manifest=[];
        swatches.forEach(function(s){
          var styleId = findStyleId(s.tags, s.sku||'');
          var colorValueName = slugify(s.title);
          var swatchImgUrl = (window.__swatchReplaceUrl||'').replace('swatch_url_source_do_not_remove.png', (styleId+'_'+colorValueName+'_sw.jpg').toLowerCase());
          manifest.push({
            colorDisplayName: s.title,
            colorValueName: colorValueName,
            handle: s.handle || handle,
            productId: product.id,
            productImgUrl: addSize(s.image,'450x'),
            swatchId: product.id + '-' + colorValueName,
            swatchImgUrl: swatchImgUrl,
            variantImgUrl: addSize(s.image,'500x'),
            variantAltImgUrl: addSize(s.imageAlt||s.image,'500x'),
            available: s.available,
            price_min: s.price_min,
            price_max: s.price_max,
            price_varies: s.price_varies,
            compare_at_price: s.compare_at_price
          });
        });
        var old = box.querySelectorAll('.cf-swatch-list'); old.forEach(function(n){ try{ n.remove(); }catch(_){} });
        box.setAttribute('data-cf-swatches', JSON.stringify(manifest));
        var list=document.createElement('div'); list.className='cf-swatch-list';
        var maxVisible = 3;
        var totalSwatches = manifest.length;
        var showCount = Math.min(maxVisible, totalSwatches);
        
        // Render visible swatches
        for (var idx = 0; idx < showCount; idx++) {
          var m = manifest[idx];
          var wrap=document.createElement('div');
          wrap.className='cf-swatch-item-wrap'+(idx===0?' active':'');
          var a=document.createElement('a');
          a.className='cf-swatch-item';
          a.setAttribute('data-title', m.colorValueName);
          a.setAttribute('title', m.colorDisplayName);
          a.style.backgroundImage='url('+m.swatchImgUrl+')';
          wrap.appendChild(a);
          list.appendChild(wrap);
        }
        
        // Add "+N" counter if there are more swatches
        if (totalSwatches > maxVisible) {
          var remaining = totalSwatches - maxVisible;
          var counterWrap = document.createElement('div');
          counterWrap.className = 'cf-swatch-counter-wrap';
          var counterLink = document.createElement('a');
          counterLink.className = 'cf-swatch-counter';
          counterLink.innerHTML = '+' + remaining + '<span class="cf-swatch-counter-more"> more</span>';
          counterLink.setAttribute('href', buildProductUrl(manifest[0]));
          counterLink.setAttribute('title', 'View all ' + totalSwatches + ' colors');
          counterWrap.appendChild(counterLink);
          list.appendChild(counterWrap);
        }
        
        var parentShow = box.closest('.product-colors') || box.parentElement; if(parentShow) parentShow.style.display='';
        box.appendChild(list);
        box.__rendered=true; box.__rendering=false;
      }catch(_e){ box.__rendering=false; }
    };
    if (cached){ proceed(cached); return; }
    fetch('/products/'+handle+'?view=merge-data', { credentials:'same-origin' })
      .then(function(r){ return r.ok? r.json(): Promise.reject(r.status); })
      .then(function(data){ window.__mergeCache[handle]=data; proceed(data); })
      .catch(function(err){ box.__rendering=false; });
  }
  function renderAll(){
    var nodes = document.querySelectorAll('.product-colors');
    nodes.forEach(function(n){ renderCard(n); });
  }
  function observe(){
    var grid=document.getElementById('ProductGridContainer');
    if(!grid || grid.__swatchObserver) return;
    var obs=new MutationObserver(function(muts){ for(var i=0;i<muts.length;i++){ if(muts[i].type==='childList' && muts[i].addedNodes.length){ renderAll(); break; } } });
    obs.observe(grid,{childList:true,subtree:true}); grid.__swatchObserver=obs;
  }
  function getManifest(box){
    if (box.__manifest) return box.__manifest;
    var raw = box.getAttribute('data-cf-swatches') || '[]';
    try { box.__manifest = JSON.parse(raw); } catch(err) { box.__manifest = []; }
    return box.__manifest;
  }
  function buildSrcSet(baseUrl){
    if (!baseUrl) return '';
    var widths = [320,480,640,800,1024];
    return widths.map(function(w){ return addSize(baseUrl, w+'x') + ' ' + w + 'w'; }).join(', ');
  }
  function setResponsiveImage(img, url){
    if (!img || !url) return;
    if (!img.dataset.cfOrigSrc){ img.dataset.cfOrigSrc = img.getAttribute('src') || ''; }
    if (!img.dataset.cfOrigSrcset){ img.dataset.cfOrigSrcset = img.getAttribute('srcset') || ''; }
    img.setAttribute('src', addSize(url, '800x'));
    img.setAttribute('srcset', buildSrcSet(url));
  }
  function buildProductUrl(sw){
    try {
      var handle = sw && sw.handle ? sw.handle : '';
      if (!handle) return '';
      return '/products/' + handle;
    } catch(_){ return ''; }
  }
  function buildProductUrlFromBase(baseHref, newHandle){
    try {
      if (!newHandle) return '';
      var url = new URL(baseHref || '', window.location.origin);
      var path = url.pathname || '';
      var replaced = path;
      if (/^\/collections\//.test(path)) {
        replaced = path.replace(/^(\/collections\/[^\/]+\/products\/)[^\/]+/, '$1' + newHandle);
      } else if (/^\/products\//.test(path)) {
        replaced = path.replace(/^(\/products\/)[^\/]+/, '$1' + newHandle);
      } else {
        replaced = '/products/' + newHandle;
      }
      return replaced + (url.search || '') + (url.hash || '');
    } catch(_) {
      return newHandle ? '/products/' + newHandle : '';
    }
  }
  function setLinksForSwatch(card, sw){
    if (!card || !sw) return;
    var anchors = card.querySelectorAll('.product-image-wrapper a, .cf-product-meta a, .cf-swatch-counter');
    anchors.forEach(function(a){
      if (!a.dataset.cfOrigHref){ a.dataset.cfOrigHref = a.getAttribute('href') || ''; }
      var baseHref = a.dataset.cfOrigHref || a.getAttribute('href') || '';
      var url = buildProductUrlFromBase(baseHref, sw && sw.handle);
      if (url) a.setAttribute('href', url);
    });
  }
  function restoreLinks(card){
    if (!card) return;
    var anchors = card.querySelectorAll('.product-image-wrapper a, .cf-product-meta a, .cf-swatch-counter');
    anchors.forEach(function(a){ if (a.dataset && a.dataset.cfOrigHref != null){ a.setAttribute('href', a.dataset.cfOrigHref); } });
  }
  function matches(el, sel){
    var fn = el && (el.matches || el.msMatchesSelector || el.webkitMatchesSelector);
    return fn ? fn.call(el, sel) : false;
  }
  function closestSafe(node, selector){
    var el = node;
    if (!el) return null;
    // If it's not an element (e.g., text node), start from parentElement
    if (el.nodeType !== 1) el = el.parentElement;
    while (el){
      if (matches(el, selector)) return el;
      el = el.parentElement;
    }
    return null;
  }
  function setPricesForSwatch(card, sw){
    if (!card || !sw) return;
    var row = card.querySelector('.cf-product-meta-bottom-row');
    if (!row) return;
    if (!row.dataset.cfOrigPriceRow) row.dataset.cfOrigPriceRow = row.innerHTML;
    var fromText = (row.getAttribute('data-from-text') || 'From ').trim();
    var fmt = (typeof window !== 'undefined' && window.__cfMoneyFormat) ? window.__cfMoneyFormat : '{{amount}}';
    var fm = function(c){ return (typeof Shopify !== 'undefined' && Shopify.formatMoney) ? Shopify.formatMoney(c, fmt) : String(c / 100); };
    var priceMin = sw.price_min != null ? sw.price_min : 0;
    var priceMax = sw.price_max != null ? sw.price_max : priceMin;
    var onSale = sw.compare_at_price != null && priceMin < sw.compare_at_price;
    var priceInner = '';
    if (onSale) {
      priceInner = '<div class="was"><span class="money">' + fm(sw.compare_at_price) + '</span></div> <div class="onsale"><span class="money">' + fm(priceMin) + '</span></div>';
    } else {
      if (sw.price_varies) {
        priceInner = '<div class="product-price">' + fromText + ' <span class="money">' + fm(priceMin) + '</span> - <span class="money">' + fm(priceMax) + '</span></div>';
      } else {
        priceInner = '<div class="product-price"><span class="money">' + fm(priceMin) + '</span></div>';
      }
    }
    var soHtml = !sw.available ? '<div class="so">Out of Stock</div>' : '';
    row.innerHTML = '<div class="price">' + priceInner + '</div>' + soHtml;
  }
  function setImagesForSwatch(card, sw){
    if (!card || !sw) return;
    var primary = card.querySelector('.cf-img--primary');
    if (!primary) return; // nothing to do on cards without primary image
    var secondary = card.querySelector('.cf-img--secondary');
    // primary
    var primaryUrl = sw.variantImgUrl || sw.productImgUrl || sw.swatchImgUrl;
    setResponsiveImage(primary, primaryUrl);
    // secondary
    if (secondary){
      var targetAlt = sw.variantAltImgUrl || sw.variantImgUrl || sw.productImgUrl || (secondary.dataset.cfOrigSrc||'');
      setResponsiveImage(secondary, targetAlt);
    }
    setPricesForSwatch(card, sw);
    setLinksForSwatch(card, sw);
  }
  function restoreImages(card){
    if (!card) return;
    var primary = card.querySelector('.cf-img--primary');
    var secondary = card.querySelector('.cf-img--secondary');
    if (primary && primary.dataset.cfOrigSrc){
      primary.setAttribute('src', primary.dataset.cfOrigSrc);
      if (primary.dataset.cfOrigSrcset){ primary.setAttribute('srcset', primary.dataset.cfOrigSrcset); }
    }
    if (secondary && secondary.dataset.cfOrigSrc){
      secondary.setAttribute('src', secondary.dataset.cfOrigSrc);
      if (secondary.dataset.cfOrigSrcset){ secondary.setAttribute('srcset', secondary.dataset.cfOrigSrcset); }
    }
    var row = card.querySelector('.cf-product-meta-bottom-row');
    if (row && row.dataset.cfOrigPriceRow) row.innerHTML = row.dataset.cfOrigPriceRow;
    restoreLinks(card);
  }
  function activeSwatch(box){ return box.querySelector('.cf-swatch-item-wrap.active .cf-swatch-item'); }

  function bindSwatchEvents(){
    if (window.__cfSwatchBound) return; window.__cfSwatchBound = true;
    // Hover preview
    document.addEventListener('mouseenter', function(e){
      var a = closestSafe(e.target, '.cf-swatch-item'); if(!a) return;
      var wrap = closestSafe(a, '.cf-swatch-item-wrap'); var box = closestSafe(a, '.cf-swatch-box'); if(!wrap||!box) return;
      var card = closestSafe(a, '.product-container') || closestSafe(a, '.grid__item');
      var title = a.getAttribute('data-title')||'';
      var manifest = getManifest(box);
      var sw = manifest.find(function(s){ return s.colorValueName === title; });
      setImagesForSwatch(card, sw);
    }, true);
    // Leave list: restore to active or original
    document.addEventListener('mouseleave', function(e){
      var list = closestSafe(e.target, '.cf-swatch-list'); if(!list) return;
      var box = closestSafe(list, '.cf-swatch-box'); var card = closestSafe(list, '.product-container') || closestSafe(list, '.grid__item'); if(!box||!card) return;
      var active = activeSwatch(box);
      if (active){
        var title = active.getAttribute('data-title')||'';
        var sw = getManifest(box).find(function(s){ return s.colorValueName===title; });
        setImagesForSwatch(card, sw);
      } else {
        restoreImages(card);
      }
    }, true);
    // Click to set active
    document.addEventListener('click', function(e){
      var a = closestSafe(e.target, '.cf-swatch-item'); if(!a) return;
      e.preventDefault();
      var wrap = closestSafe(a, '.cf-swatch-item-wrap'); var box = closestSafe(a, '.cf-swatch-box'); if(!wrap||!box) return;
      var card = closestSafe(a, '.product-container') || closestSafe(a, '.grid__item');
      box.querySelectorAll('.cf-swatch-item-wrap.active').forEach(function(n){ n.classList.remove('active'); });
      wrap.classList.add('active');
      var title = a.getAttribute('data-title')||'';
      var sw = getManifest(box).find(function(s){ return s.colorValueName===title; });
      setImagesForSwatch(card, sw);
      // Ensure links updated on click as well
      setLinksForSwatch(card, sw);
    });
  }
  if (document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', function(){ renderAll(); observe(); bindSwatchEvents(); }); } else { renderAll(); observe(); bindSwatchEvents(); }
})();

// Scroll lock: toggle a class on body when the mobile facets drawer opens
// Note: Only apply to body, NOT html - Firefox clips fixed elements when html has overflow:hidden
(function(){
  function handleToggle(e){
    var details = e && e.target;
    if (!details || details.tagName !== 'DETAILS') return;
    var drawer = details.closest && details.closest('menu-drawer.mobile-facets__wrapper');
    if (!drawer) return;

    // Only handle scroll lock if this is the drawer's direct details element
    if (details !== drawer.querySelector(':scope > details')) return;

    var method = details.open ? 'add' : 'remove';
    document.body.classList[method]('no-scroll');
  }
  document.addEventListener('toggle', handleToggle, true);
  // If it starts open, ensure lock is applied (only for the main drawer, not nested facet accordions)
  try {
    var drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    var mainDetails = drawer ? drawer.querySelector(':scope > details') : null;
    if (mainDetails && mainDetails.open) {
      document.body.classList.add('no-scroll');
    }
  } catch(_){}
})();

// Persist facet accordion open states across drawer open/close
(function(){
  var STORAGE_KEY = 'facet-open-states';
  var STORAGE_PATH_KEY = 'facet-open-states-path';
  
  function getCurrentPathname() {
    // Get the pathname without query params to identify the collection/page
    return window.location.pathname;
  }
  
  function getFacetDetails(drawer) {
    if (!drawer) return [];
    // Get all facet details inside the drawer (not the main drawer toggle)
    return Array.from(drawer.querySelectorAll('.mobile-facets__details, details.disclosure-has-popup'));
  }
  
  function saveOpenStates(drawer) {
    var facetDetails = getFacetDetails(drawer);
    var openIds = [];
    facetDetails.forEach(function(det) {
      if (det.hasAttribute('open')) {
        var id = det.id || det.dataset.index || det.querySelector('summary')?.textContent?.trim();
        if (id) openIds.push(id);
      }
    });
    var currentPath = getCurrentPathname();
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(openIds));
      // Store the current pathname so we can verify it matches when restoring
      sessionStorage.setItem(STORAGE_PATH_KEY, currentPath);
    } catch(_){}
  }
  
  function restoreOpenStates(drawer) {
    var openIds = [];
    var storedPath = '';
    try {
      openIds = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      storedPath = sessionStorage.getItem(STORAGE_PATH_KEY) || '';
    } catch(_){}
    
    // Only restore if we're on the same collection/page
    var currentPath = getCurrentPathname();
    if (storedPath !== currentPath) {
      // Clear stored states if we're on a different page
      try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_PATH_KEY);
      } catch(_){}
      return;
    }
    
    if (!openIds.length) return;
    
    var facetDetails = getFacetDetails(drawer);
    facetDetails.forEach(function(det) {
      var id = det.id || det.dataset.index || det.querySelector('summary')?.textContent?.trim();
      if (id && openIds.includes(id)) {
        det.setAttribute('open', '');
      }
    });
  }
  
  // Listen for drawer toggle
  document.addEventListener('toggle', function(e) {
    var details = e && e.target;
    if (!details || details.tagName !== 'DETAILS') return;
    var drawer = details.closest && details.closest('menu-drawer.mobile-facets__wrapper');
    if (!drawer) return;
    
    // Only handle the main drawer toggle, not nested facet accordions
    var mainDetails = drawer.querySelector(':scope > details');
    if (details !== mainDetails) return;
    
    if (details.open) {
      // Drawer opening - restore states after a tick (after closeMenuDrawer resets them)
      setTimeout(function() { restoreOpenStates(drawer); }, 0);
    } else {
      // Drawer closing - save states before they get reset
      // Note: toggle fires after the state changes, so we need to save before close
    }
  }, true);
  
  // Save states right before they get cleared by closeMenuDrawer
  document.addEventListener('click', function(e) {
    var drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    if (!drawer) return;
    var mainDetails = drawer.querySelector(':scope > details');
    if (!mainDetails || !mainDetails.hasAttribute('open')) return;
    
    // Check if click will close the drawer (close button, overlay, etc.)
    var closeBtn = e.target.closest('.mobile-facets__close-button, .mobile-facets__close');
    var summary = e.target.closest('summary');
    var isMainSummary = summary && summary.parentElement === mainDetails;
    var isOverlay = e.target.classList.contains('mobile-facets__overlay');
    
    if (closeBtn || isMainSummary || isOverlay) {
      saveOpenStates(drawer);
    }
  }, true);
  
  // Also save on Escape key
  document.addEventListener('keyup', function(e) {
    if (e.key !== 'Escape') return;
    var drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    if (!drawer) return;
    var mainDetails = drawer.querySelector(':scope > details');
    if (mainDetails && mainDetails.hasAttribute('open')) {
      saveOpenStates(drawer);
    }
  }, true);
  
  // Mobile sort dropdown: close picker when tapping label while open
  (function() {
    var sortSelect = document.getElementById('SortByDrawer');
    if (!sortSelect) return;
    
    var sortField = sortSelect.closest('.sort-controls__field');
    if (!sortField) return;
    
    var isPickerOpen = false;
    
    sortField.addEventListener('touchstart', function(e) {
      if (isPickerOpen) {
        e.preventDefault();
        e.stopPropagation();
        sortSelect.blur();
        isPickerOpen = false;
      } else {
        setTimeout(function() { isPickerOpen = true; }, 100);
      }
    }, {passive: false});
    
    sortSelect.addEventListener('change', function() {
      isPickerOpen = false;
    });
  })();
})();